import type { IconSvgObject } from './types';

const ReceiptPoundSterlingIcon: IconSvgObject = [
  ["path", { d: "M9.5 2L12 3.5L14.5 2L17 3.5L20 2V22L17 20.5L14.5 22L12 20.5L9.5 22L7 20.5L4 22V2L7 3.5L9.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 16H9C10.1046 16 11 15.1046 11 14L11 9.5C11 8.39543 11.8954 7.5 13 7.5C14.1046 7.5 15 8.39543 15 9.5M9 12H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ReceiptPoundSterlingIcon;
